import Immutable from 'seamless-immutable';
// ---- external imports ----

import * as types from './actionTypes';
import HINTS from './hints.json';
// ---- local imports ----

const initialState = Immutable({
	hintsList: HINTS,
	currentHint: null,
	areHintsDisabled:  localStorage.getItem('areHintsDisabled') === 'true',
});

function showHint(state, hintToDisplay) {
	// const updatedHintsList = state.hintsList.filter((h) => h.id !== hintToDisplay.id);

	return state.merge({
		currentHint: hintToDisplay,
	});
}

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.HINTS_SHOW_HINT:
		return showHint(state, action.hintToDisplay);
	case types.HINTS_HIDE_HINT:
		return state.merge({
			currentHint: null
		});
	case types.HINTS_SET_USE_HINTS:
		return state.merge({
			areHintsDisabled: action.areHintsDisabled
		});
	default:
		return state;
	}
}
